import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["limit", "defaultActiveId", "includesBaseElement", "orientation", "focusLoop", "focusWrap", "placement", "virtualFocus"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useState, useMemo } from 'react';
import { useControlledState, usePreviousValue, useDeferredValue, useUpdateLayoutEffect } from 'ariakit-utils/hooks';
import { normalizeString } from 'ariakit-utils/misc';
import { isSafari, isTouchDevice } from 'ariakit-utils/platform';
import { useStorePublisher } from 'ariakit-utils/store';
import { useCompositeState } from '../composite/composite-state.js';
import { usePopoverState } from '../popover/popover-state.js';
var isSafariOnMobile = isSafari() && isTouchDevice();

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getMatches(props) {
  if (props.limit === 0) return [];
  var value = normalizeString(props.value);
  var size = props.limit === false ? undefined : props.limit;
  var regex = new RegExp(escapeRegExp(value), "i");
  var matches = new Set(); // Get first the values that start with the search value.

  var _iterator = _createForOfIteratorHelper(props.list),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var v = _step.value;
      if (size && matches.size >= size) break;

      if (normalizeString(v).search(regex) === 0) {
        matches.add(v);
      }
    } // Then get any value that matches the search value.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = _createForOfIteratorHelper(props.list),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _v = _step2.value;
      if (size && matches.size >= size) break;

      if (regex.test(normalizeString(_v))) {
        matches.add(_v);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return Array.from(matches);
}
/**
 * Provides state for the `Combobox` components.
 * @see https://ariakit.org/components/combobox
 * @example
 * ```jsx
 * const combobox = useComboboxState();
 * <Combobox state={combobox} />
 * <ComboboxPopover state={combobox}>
 *   <ComboboxItem>Item 1</ComboboxItem>
 *   <ComboboxItem>Item 2</ComboboxItem>
 *   <ComboboxItem>Item 3</ComboboxItem>
 * </ComboboxPopover>
 * ```
 */


function useComboboxState(_temp) {
  var _props$defaultValue;

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? false : _ref$limit,
      _ref$defaultActiveId = _ref.defaultActiveId,
      defaultActiveId = _ref$defaultActiveId === void 0 ? null : _ref$defaultActiveId,
      _ref$includesBaseElem = _ref.includesBaseElement,
      includesBaseElement = _ref$includesBaseElem === void 0 ? true : _ref$includesBaseElem,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? "vertical" : _ref$orientation,
      _ref$focusLoop = _ref.focusLoop,
      focusLoop = _ref$focusLoop === void 0 ? true : _ref$focusLoop,
      _ref$focusWrap = _ref.focusWrap,
      focusWrap = _ref$focusWrap === void 0 ? true : _ref$focusWrap,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "bottom-start" : _ref$placement,
      _ref$virtualFocus = _ref.virtualFocus,
      virtualFocus = _ref$virtualFocus === void 0 ? !isSafariOnMobile : _ref$virtualFocus,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useControlledState = useControlledState((_props$defaultValue = props.defaultValue) != null ? _props$defaultValue : "", props.value, props.setValue),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      value = _useControlledState2[0],
      setValue = _useControlledState2[1];

  var _useControlledState3 = useControlledState(props.defaultList || [], props.list, props.setList),
      _useControlledState4 = _slicedToArray(_useControlledState3, 2),
      list = _useControlledState4[0],
      setList = _useControlledState4[1];

  var composite = useCompositeState(_objectSpread(_objectSpread({}, props), {}, {
    defaultActiveId: defaultActiveId,
    orientation: orientation,
    focusLoop: focusLoop,
    focusWrap: focusWrap,
    virtualFocus: virtualFocus,
    includesBaseElement: includesBaseElement
  }));
  var popover = usePopoverState(_objectSpread(_objectSpread({}, props), {}, {
    placement: placement
  }));
  var prevActiveId = usePreviousValue(composite.activeId);
  var prevMoves = usePreviousValue(composite.moves);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      moved = _useState2[0],
      setMoved = _useState2[1];

  if (prevActiveId !== composite.activeId) {
    setMoved(prevMoves !== composite.moves);
  } // Update the active value when the active item changes by moving (which
  // usually happens when using the keyboard).


  var activeValue = useMemo(function () {
    var _composite$items$find;

    if (!moved) return undefined;
    return (_composite$items$find = composite.items.find(function (item) {
      return item.id === composite.activeId && item.value;
    })) == null ? void 0 : _composite$items$find.value;
  }, [moved, composite.items, composite.activeId]);
  var deferredValue = useDeferredValue(value);
  var matches = useMemo(function () {
    return getMatches({
      limit: limit,
      list: list,
      value: deferredValue
    });
  }, [limit, list, deferredValue]); // Resets the combobox state when it gets hidden. This effect should be sync
  // (layout effect), otherwise pressing tab while focusing on a combobox item
  // will always put focus back on the combobox input. See
  // ../composite/composite.ts#132

  useUpdateLayoutEffect(function () {
    if (popover.open) return; // We need to reset the composite state when the popover is closed.

    composite.setActiveId(defaultActiveId);
    composite.setMoves(0);
  }, [popover.open, composite.setActiveId, composite.setMoves]);
  var state = useMemo(function () {
    return _objectSpread(_objectSpread(_objectSpread({}, composite), popover), {}, {
      value: value,
      setValue: setValue,
      activeValue: activeValue,
      list: list,
      setList: setList,
      limit: limit,
      matches: matches
    });
  }, [composite, popover, value, setValue, activeValue, list, setList, limit, matches]);
  return useStorePublisher(state);
}

export { useComboboxState };